/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function gravurSetup(){
  document.getElementById("gravurOpener").onclick = function(){toggleGravurPopup()};
  document.getElementById("closer").onclick = function(){toggleGravurPopup()};

  var changeGravurInput = document.getElementsByClassName("changeGravurInput");
  for(var i = 0; i < changeGravurInput.length; i++){
    changeGravurInput[i].onclick = function(){toggleGravurInput(event, this)};
  }
  var GravurFontFamilySelector = document.getElementsByClassName("GravurFontFamilySelector");
  for(var i = 0; i < GravurFontFamilySelector.length; i++){
    GravurFontFamilySelector[i].onchange = function(){setFontFamily(event, this)};
  }
  var GravurTextInput = document.getElementsByClassName("GravurTextInput");
  for(var i = 0; i < GravurTextInput.length; i++){
    GravurTextInput[i].onkeyup = function(){copyText(event, this)};
  }
 /*
  document.getElementById("gravurminus").onclick = function(){setQtyGravur('-1')};
  document.getElementById("gravurplus").onclick = function(){setQtyGravur('+1')};
  document.getElementById("gravurQty").onchange = function(){setQtyGravur(this.value)};*/
  // document.getElementById("addGravurToCart").onclick = function(){addGravurToCart()};
  document.getElementById("addGravurToCartNew").onclick = function(){addGravurToCartNew()};
}

function changeGravurImage(e , pthis) {
  var changeGravurImage = document.getElementsByClassName("changeGravurImage");

  changeGravurImage.forEach(element => {
    if (element.id != 'imgEtui') {
      if (pthis.value == 'left') {
        element.classList.add('left');
      } else {
        element.classList.remove('left');
      }
    }
 });
}

function toggleGravurPopup(){
    var wrapper = document.getElementById("gravur-wrapper");
    wrapper.classList.toggle("Open");
  var changeGravurInput = document.getElementsByClassName("changeGravurInput");
}
function toggleGravurInput(e, pthis){
    var changeGravurInput = document.getElementsByClassName("Gravur--input-c");
    for(var i = 0; i < changeGravurInput.length; i++){
      if(pthis.getAttribute("change-id") ==  changeGravurInput[i].id){
          changeGravurInput[i].classList.add("active");
      } else{
        changeGravurInput[i].classList.remove("active");
      }
    }
  var changeGravurImage = document.getElementsByClassName("changeGravurImage");
  for(var i = 0; i < changeGravurImage.length; i++){
      if(pthis.getAttribute("change-id") ==  changeGravurImage[i].getAttribute("change-id")){
          changeGravurImage[i].classList.add("active");
      } else{
        changeGravurImage[i].classList.remove("active");
      }
  }
   var changeGravurBtn = document.getElementsByClassName("changeGravurInput");
  for(var i = 0; i < changeGravurBtn.length; i++){
      if(pthis.getAttribute("change-id") ==  changeGravurBtn[i].getAttribute("change-id")){
          changeGravurBtn[i].classList.add("shopify-payment-button__button--unbranded");
          changeGravurBtn[i].classList.remove("Button--secondary");
      } else{
        changeGravurBtn[i].classList.remove("shopify-payment-button__button--unbranded");
          changeGravurBtn[i].classList.add("Button--secondary");
      }
  }
}

function setFontFamily(e, pthis) {
  var changeGravurImageFontFamily = document.getElementsByClassName("changeGravurImageFontFamily");
  for(var i = 0; i < changeGravurImageFontFamily.length; i++){
      if(pthis.getAttribute("change-id") ==  changeGravurImageFontFamily[i].getAttribute("change-id")){
          changeGravurImageFontFamily[i].style.fontFamily = pthis.value;
      }
  }
}
function copyText(e, pthis) {
  var changeGravurImageFontFamily = document.getElementsByClassName("changeGravurImageFontFamily");
  for(var i = 0; i < changeGravurImageFontFamily.length; i++){
      if(pthis.getAttribute("change-id") ==  changeGravurImageFontFamily[i].getAttribute("change-id")){
          if(pthis.getAttribute("change-id") == "inputClip"){
            var showtext =   pthis.value.split("");
            showtexttotal = "";
            for(var i2 = 0; i2 < showtext.length; i2++){
              showtexttotal = showtexttotal + showtext[i2] + ".";
            }
            changeGravurImageFontFamily[i].innerHTML = showtexttotal;
          }else{
          changeGravurImageFontFamily[i].innerHTML = pthis.value;
          }
      }
  }
}
function addGravurToCart() {  
  var form = document.getElementsByClassName("ProductForm");
  form = form[0];

  var GravurFontFamilySelector = document.getElementsByClassName("GravurFontFamilySelector");
  var changeGravurInput = document.getElementsByClassName("GravurTextInput");
  var atleastOne = false;
  for(var i = 0; i < changeGravurInput.length; i++){
    changeGravurInput[i].onclick = function(){toggleGravurInput(event, this)};
    var clone = changeGravurInput[i].cloneNode(true);
    clone.className = 'hidden';
    form.appendChild(clone);

    if (clone.value != ""){
      atleastOne = true;
      var clone2 = document.createElement("INPUT");
      clone2.setAttribute("type", "text");
      clone2.setAttribute("value", GravurFontFamilySelector[i].value);
      clone2.setAttribute("name", GravurFontFamilySelector[i].getAttribute("name"));
      form.appendChild(clone2);
   }
  }

  var clone3 = document.createElement("INPUT");
  clone3.setAttribute("type", "text");
  clone3.setAttribute("value", document.getElementById("LeftRight").value);
  clone3.setAttribute("name", document.getElementById("LeftRight").getAttribute("name"));
  form.appendChild(clone3);

  // add gravur to cart as a separate product
  if (document.getElementById('gravur-product-id')) {
    let infoJson = JSON.parse(document.getElementById('gravur-product-id').textContent);
    let gravurProductId = infoJson.gravurProductId;
    let productPrice = infoJson.productPrice;

    if (productPrice < 9900) {
      let data = {
        'id': gravurProductId,
        'quantity': 1
      };
    
      fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      }).then(function(response) {
        return response.json();
      }).then(function(json) {
        var form_btn = document.getElementById("addToCartButton");
        if(atleastOne){
          form_btn.click();
        }
      }).catch(function(err) {
        console.error(err)
      });
    }
  }

  clone.remove();

  if (clone2 != null) {
    clone2.remove();
  }

  clone3.remove();

  if (atleastOne) {
    toggleGravurPopup();
  }
}

function addGravurToCartNew() {
  if (document.getElementById('gravur-product-id')) {
    let infoJson = JSON.parse(document.getElementById('gravur-product-id').textContent);
    let gravurId = infoJson.gravurProductId; // if for the "gravur" product for 20€

    let productPrice = infoJson.productPrice;
    let productId = parseInt(document.querySelector('.ProductForm__Variants [name="id"]').value);
    let productQuantity = parseInt(document.getElementById('CurrentQuantity').value);
    
    let gravurKey = document.querySelector('.Gravur--input-c.active input').getAttribute('name').split('[')[1].slice(0, -1)
    let gravurValue = document.querySelector('.Gravur--input-c.active input').value;

    let fontKey = document.querySelector('.Gravur--input-c.active select').getAttribute('name').split('[')[1].slice(0, -1);
    let fontValue = document.querySelector('.Gravur--input-c.active .GravurFontFamilySelector').value;
    
    let handednessSelector = document.getElementById('LeftRight');
    let handednessKey = handednessSelector.getAttribute('name').split('[')[1].slice(0, -1);
    let handednessValue = handednessSelector.options[handednessSelector.selectedIndex].text;


    let data = {};

    if (productPrice < 9900) {
      data.items = [
        {
          id: productId,
          quantity: productQuantity,
          properties: {}
        },
        {
          id: gravurId,
          quantity: 1
        }
      ];
    } else {
      data.items = [
        {
          id: productId,
          quantity: productQuantity,
          properties: {}
        }
      ];
    }
    
    data.items[0].properties[gravurKey] = gravurValue;
    data.items[0].properties[fontKey] = fontValue;
    data.items[0].properties[handednessKey] = handednessValue;
  
    fetch('/cart/add.js', {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then(function(response) {
      if (response.status == 422) {
        alert('Hinzufügen nicht möglich aufgrund von der Produktverfügbarkeit');
      };
      return response.json();
    }).then(function(json) {
      // window.location.href = "/cart";
      window.location.reload();
    }).catch(function(err) {
      console.error(err)
    });

    toggleGravurPopup();
  }
}

function setQtyGravur(pNum){
  var input = document.getElementById("CurrentQuantity");
  if(pNum == "+1"){
    var btn = document.getElementById("increase-quantity");
    btn.click();	
  }else if(pNum == "-1"){
    var btn = document.getElementById("decrease-quantity");
    btn.click();
  }else{
    var input = document.getElementById("CurrentQuantity");
    input.value = pNum;
  }
  document.getElementById("gravurQty").value = input.value;
}

function variantChange() {
   /*var txt = document.getElementsByClassName("shipping_time_delivery");
  setTimeout(function() {
    if(document.getElementById("addToCartButton").disabled){
      txt[0].classList.add("hidden");
    }else{
      txt[0].classList.remove("hidden");
    }
  }, 100);*/
}
function checkCheckbox(event, sectionid){
    event.preventDefault();
    var form = document.getElementById("footer-" + sectionid);
    var checkbox = document.getElementById("checkbox-" + sectionid);
    if(checkbox.checked){
      document.getElementById("errorcheckbox-" + sectionid).style.display = "none";
      event.target.removeAttribute("onclick");
      event.target.click();
    }else{
      document.getElementById("errorcheckbox-" + sectionid).style.display ="block";
    }
}

function getCookie(name) { 
      var dc = document.cookie;
      var prefix = name + "=";
      var begin = dc.indexOf("; " + prefix);
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
      }
      else
      {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
          end = dc.length;
        }
      }
      return decodeURI(dc.substring(begin + prefix.length, end));
}

function setCookie(cname, cvalue, exdays, event) {
    // console.log("setcookie" + cvalue);
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/; secure;";
 // setupCookieBody();
}

function setupCookie(){
    var links = document.getElementsByClassName("setupCookieClick");
    for(var i = 0; i < links.length;i++){
      links[i].addEventListener("click", function(event){
        event.prevDefault
        setCookie("markenwelt-choose",this.getAttribute("id-link"), 1, event);
        this.click();
      });
    }
    setupCookieBody();
}
function setupCookieBody(){
  if(Cookies.get('template_suffix') == undefined){
      setCookie("markenwelt-choose","main-menu", 1, null);
  } 
  var cookiemarkenwelt = getCookie("markenwelt-choose");
  var cookiedivs = document.getElementsByClassName("marken-welt-" + cookiemarkenwelt);
  var sidebar = document.getElementById("sidebar-menu");
  if (cookiedivs.length == 0) {
    // console.log("nodiv");
    return setCookie("markenwelt-choose","main-menu", 1, null);
  }
  var list = document.body.classList;
   for(var i = 0; i < list.length;i++){
     if(list[i].includes("wrapper-marken-welt-")){
        document.body.classList.remove(list[i]);
     }
   }
  list = sidebar.classList;
  for(var i = 0; i < list.length;i++){
     if(list[i].includes("wrapper-marken-welt-")){
        document.body.classList.remove(list[i]);
     }
   }
  if(cookiemarkenwelt == "" || cookiemarkenwelt == null){
        cookiemarkenwelt = "main-menu";
  }
  document.body.classList.add("wrapper-marken-welt-" + cookiemarkenwelt );
  sidebar.classList.add("wrapper-marken-welt-" + cookiemarkenwelt );
}

setupCookieBody();